import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddCashierPage } from './add-cashier.page';

const routes: Routes = [
  {
    path: '',
    component: AddCashierPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddCashierPageRoutingModule {}
